<div class="topline">
    <h1>Broker</h1>

    <mat-form-field *ngIf="brokers.length > 0">
        <mat-label>Current Broker</mat-label>

        <mat-select
                [(value)]="selectedBrokerId"
                (selectionChange)="setBrokerId($event.value)">
            <mat-option *ngFor="let broker of brokers" [value]="broker.id">
                {{ broker.name }} ({{ brokerAgencyCounts[broker.id] || 0 }})
            </mat-option>
        </mat-select>
    </mat-form-field>

    <h1 *ngIf="brokers.length === 0">
        {{ brokerName }}
    </h1>
</div>

<app-infoband [items]="info"></app-infoband>

<nav mat-tab-nav-bar [tabPanel]="tabs">
    <a
            mat-tab-link
            *ngFor="let link of links"
            (click)="gotoTab(link)"
            [active]="activeLink?.title === link.title">
        {{ link.title }}
    </a>
</nav>

<ng-container *ngIf="!selectedBrokerId">
    <app-inlinemessage
            class="info"
            level="info"
            message="Please select a broker so that you can update their profile, agencies, and products">
    </app-inlinemessage>
</ng-container>

<ng-container *ngIf="selectedBrokerId">
    <app-broker-profile
            *ngIf="activeLink?.title === 'Profile'"
            [companyId]="selectedBrokerId">
    </app-broker-profile>

    <app-broker-agencies
            *ngIf="activeLink?.title === 'Agencies'"
            [companyId]="selectedBrokerId"
            [enabled]="true"
            (countEvent)="setCount('Agencies', $event)">
    </app-broker-agencies>

    <app-broker-products
            *ngIf="activeLink?.title === 'Products'"
            [companyId]="selectedBrokerId"
            [enabled]="true"
            (countEvent)="setCount('Products', $event)">
    </app-broker-products>
</ng-container>

<mat-tab-nav-panel #tabs></mat-tab-nav-panel>
